/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACE
import { OrganizationInterface, OrganizationBreadcrumbInterface } from "../../interfaces/Organizations.interface";

interface OrganizationState {
	organization: OrganizationInterface;
	openModalDeleteOrganization: boolean;
	formAction: "create" | "edit";
	openModalCreateNewOrganization: boolean;
	openModalCreateSubOrganization: boolean;
	openModalEditOrganization: boolean;
	openDrawerOrganization: boolean;
	openDrawerHolidays: boolean;
	organizationRefreshTable: boolean;
	organizationList: Array<any>;
	organizationAndChilds: {
		data: {
			idOrganizationSelected: string;
		};
		childs: [];
	};
	organizationBreadcrumb: OrganizationBreadcrumbInterface[];
	organizationMonitoringViewData: any;
	organizationSelectMultipleData: Array<any>;
	clearFilters: boolean;
	tourClickActions: boolean;
}

const initialState: OrganizationState = {
	organization: {
		id: "",
		address: "",
		city: "",
		country: "",
		name: "",
		parent_id: "",
		phone_code: "",
		phone: "",
		state: "",
		type: "ORG",
	},
	openModalDeleteOrganization: false,
	formAction: "create",
	openModalCreateNewOrganization: false,
	openModalCreateSubOrganization: false,
	openModalEditOrganization: false,
	openDrawerOrganization: false,
	openDrawerHolidays: false,
	organizationRefreshTable: false,
	organizationList: [],
	organizationAndChilds: {
		data: {
			idOrganizationSelected: "",
		},
		childs: [],
	},
	organizationBreadcrumb: [],
	organizationMonitoringViewData: [],
	organizationSelectMultipleData: [],
	clearFilters: false,
	tourClickActions: false,
};

export const organizationSlice = createSlice({
	name: "organization",
	initialState,
	reducers: {
		updateOrganization: (state, action: PayloadAction<OrganizationInterface>) => {
			state.organization = action.payload;
		},
		updateFormAction: (state, action: PayloadAction<"create" | "edit">) => {
			state.formAction = action.payload;
		},
		updateOpenModalCreateNewOrganization: (state, action: PayloadAction<boolean>) => {
			state.openModalCreateNewOrganization = action.payload;
		},
		updateOpenModalCreateSubOrganization: (state, action: PayloadAction<boolean>) => {
			state.openModalCreateSubOrganization = action.payload;
		},
		updateOpenModalDeleteOrganization: (state, action: PayloadAction<boolean>) => {
			state.openModalDeleteOrganization = action.payload;
		},
		updateOpenModalEditOrganization: (state, action: PayloadAction<boolean>) => {
			state.openModalEditOrganization = action.payload;
		},
		updateOpenDrawerOrganization: (state, action: PayloadAction<boolean>) => {
			state.openDrawerOrganization = action.payload;
		},
		updateOpenDrawerHolidays: (state, action: PayloadAction<boolean>) => {
			state.openDrawerHolidays = action.payload;
		},
		updateOrganizationRefreshTable: (state, action: PayloadAction<boolean>) => {
			state.organizationRefreshTable = action.payload;
		},
		updateOrganizationList: (state, action: PayloadAction<any>) => {
			state.organizationList = action.payload;
		},
		updateOrganizationAndChilds: (state, action: PayloadAction<any>) => {
			state.organizationAndChilds = action.payload;
		},
		updateOrganizationBreadcrumb: (state, action: PayloadAction<OrganizationBreadcrumbInterface[]>) => {
			state.organizationBreadcrumb = action.payload;
		},
		updateOrganizationMonitoringViewData: (state, action: PayloadAction<any>) => {
			state.organizationMonitoringViewData = action.payload;
		},
		updateOrganizationSelectMultipleData: (state, action: PayloadAction<any>) => {
			state.organizationSelectMultipleData = action.payload;
		},
		updateClearFilters: (state, action: PayloadAction<boolean>) => {
			state.clearFilters = action.payload;
		},
		updateTourClickActions: (state, action: PayloadAction<boolean>) => {
			state.tourClickActions = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	updateOrganization,
	updateOpenModalCreateNewOrganization,
	updateOpenModalDeleteOrganization,
	updateFormAction,
	updateOpenModalCreateSubOrganization,
	updateOpenModalEditOrganization,
	updateOpenDrawerOrganization,
	updateOpenDrawerHolidays,
	updateOrganizationRefreshTable,
	updateOrganizationList,
	updateOrganizationAndChilds,
	updateOrganizationBreadcrumb,
	updateOrganizationMonitoringViewData,
	updateOrganizationSelectMultipleData,
	updateClearFilters,
	updateTourClickActions,
} = organizationSlice.actions;

export default organizationSlice.reducer;
